/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ReferralControllerBind200,
  ReferralControllerBind401,
  ReferralControllerBind429,
  ReferralControllerBindBody,
  ReferralControllerClaimMpBonuses200,
  ReferralControllerClaimMpBonuses429,
  ReferralControllerClaimUsdtBonuses200,
  ReferralControllerClaimUsdtBonuses429,
  ReferralControllerClearForUser200,
  ReferralControllerClearForUser401,
  ReferralControllerClearForUser429,
  ReferralControllerClearForUserParams,
  ReferralControllerGetBalance200,
  ReferralControllerGetBalance429,
  ReferralControllerGetLink200,
  ReferralControllerGetLink429,
  ReferralControllerList200,
  ReferralControllerList429,
  ReferralControllerListParams,
  ReferralControllerSetUserBonusConfig200,
  ReferralControllerSetUserBonusConfig429,
  SetUserBonusConfigDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns a unique referral code for the current user.
 * @summary Get my referral code
 */
export const referralControllerGetLink = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerGetLink200>(
      {url: `/referrals/link`, method: 'GET', signal
    },
      options);
    }
  

export const getReferralControllerGetLinkQueryKey = () => {
    return [`/referrals/link`] as const;
    }

    
export const getReferralControllerGetLinkQueryOptions = <TData = Awaited<ReturnType<typeof referralControllerGetLink>>, TError = null | ReferralControllerGetLink429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReferralControllerGetLinkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof referralControllerGetLink>>> = ({ signal }) => referralControllerGetLink(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReferralControllerGetLinkQueryResult = NonNullable<Awaited<ReturnType<typeof referralControllerGetLink>>>
export type ReferralControllerGetLinkQueryError = null | ReferralControllerGetLink429


export function useReferralControllerGetLink<TData = Awaited<ReturnType<typeof referralControllerGetLink>>, TError = null | ReferralControllerGetLink429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerGetLink>>,
          TError,
          Awaited<ReturnType<typeof referralControllerGetLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerGetLink<TData = Awaited<ReturnType<typeof referralControllerGetLink>>, TError = null | ReferralControllerGetLink429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerGetLink>>,
          TError,
          Awaited<ReturnType<typeof referralControllerGetLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerGetLink<TData = Awaited<ReturnType<typeof referralControllerGetLink>>, TError = null | ReferralControllerGetLink429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get my referral code
 */

export function useReferralControllerGetLink<TData = Awaited<ReturnType<typeof referralControllerGetLink>>, TError = null | ReferralControllerGetLink429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetLink>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReferralControllerGetLinkQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Shows pending referral bonuses in the reserved pool and claim window meta (last and next claim timestamps, claim periods).
 * @summary Get pending referral balance
 */
export const referralControllerGetBalance = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerGetBalance200>(
      {url: `/referrals/balance`, method: 'GET', signal
    },
      options);
    }
  

export const getReferralControllerGetBalanceQueryKey = () => {
    return [`/referrals/balance`] as const;
    }

    
export const getReferralControllerGetBalanceQueryOptions = <TData = Awaited<ReturnType<typeof referralControllerGetBalance>>, TError = null | ReferralControllerGetBalance429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReferralControllerGetBalanceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof referralControllerGetBalance>>> = ({ signal }) => referralControllerGetBalance(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReferralControllerGetBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof referralControllerGetBalance>>>
export type ReferralControllerGetBalanceQueryError = null | ReferralControllerGetBalance429


export function useReferralControllerGetBalance<TData = Awaited<ReturnType<typeof referralControllerGetBalance>>, TError = null | ReferralControllerGetBalance429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerGetBalance>>,
          TError,
          Awaited<ReturnType<typeof referralControllerGetBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerGetBalance<TData = Awaited<ReturnType<typeof referralControllerGetBalance>>, TError = null | ReferralControllerGetBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerGetBalance>>,
          TError,
          Awaited<ReturnType<typeof referralControllerGetBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerGetBalance<TData = Awaited<ReturnType<typeof referralControllerGetBalance>>, TError = null | ReferralControllerGetBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pending referral balance
 */

export function useReferralControllerGetBalance<TData = Awaited<ReturnType<typeof referralControllerGetBalance>>, TError = null | ReferralControllerGetBalance429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerGetBalance>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReferralControllerGetBalanceQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Lists users referred by me with registration metadata, bonus details, and their personal balances. Supports cursor-based pagination.
 * @summary List my referrals with bonus details
 */
export const referralControllerList = (
    params?: ReferralControllerListParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerList200>(
      {url: `/referrals/list`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getReferralControllerListQueryKey = (params?: ReferralControllerListParams,) => {
    return [`/referrals/list`, ...(params ? [params]: [])] as const;
    }

    
export const getReferralControllerListQueryOptions = <TData = Awaited<ReturnType<typeof referralControllerList>>, TError = null | ReferralControllerList429>(params?: ReferralControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReferralControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof referralControllerList>>> = ({ signal }) => referralControllerList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReferralControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof referralControllerList>>>
export type ReferralControllerListQueryError = null | ReferralControllerList429


export function useReferralControllerList<TData = Awaited<ReturnType<typeof referralControllerList>>, TError = null | ReferralControllerList429>(
 params: undefined |  ReferralControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerList>>,
          TError,
          Awaited<ReturnType<typeof referralControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerList<TData = Awaited<ReturnType<typeof referralControllerList>>, TError = null | ReferralControllerList429>(
 params?: ReferralControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralControllerList>>,
          TError,
          Awaited<ReturnType<typeof referralControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferralControllerList<TData = Awaited<ReturnType<typeof referralControllerList>>, TError = null | ReferralControllerList429>(
 params?: ReferralControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List my referrals with bonus details
 */

export function useReferralControllerList<TData = Awaited<ReturnType<typeof referralControllerList>>, TError = null | ReferralControllerList429>(
 params?: ReferralControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralControllerList>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReferralControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Claims all pending MP bonuses for the current user. Rate limited to once every 8 hours. Requires Idempotency-Key header.
 * @summary Claim all pending MP referral bonuses
 */
export const referralControllerClaimMpBonuses = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerClaimMpBonuses200 | null>(
      {url: `/referrals/claim/mp`, method: 'POST', signal
    },
      options);
    }
  


export const getReferralControllerClaimMpBonusesMutationOptions = <TError = null | null | ReferralControllerClaimMpBonuses429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>, TError,void, TContext> => {

const mutationKey = ['referralControllerClaimMpBonuses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>, void> = () => {
          

          return  referralControllerClaimMpBonuses(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralControllerClaimMpBonusesMutationResult = NonNullable<Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>>
    
    export type ReferralControllerClaimMpBonusesMutationError = null | null | ReferralControllerClaimMpBonuses429

    /**
 * @summary Claim all pending MP referral bonuses
 */
export const useReferralControllerClaimMpBonuses = <TError = null | null | ReferralControllerClaimMpBonuses429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referralControllerClaimMpBonuses>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getReferralControllerClaimMpBonusesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Claims all pending USDT bonuses for the current user. Rate limited to once every 22 hours. Requires Idempotency-Key header.
 * @summary Claim all pending USDT referral bonuses
 */
export const referralControllerClaimUsdtBonuses = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerClaimUsdtBonuses200 | null>(
      {url: `/referrals/claim/usdt`, method: 'POST', signal
    },
      options);
    }
  


export const getReferralControllerClaimUsdtBonusesMutationOptions = <TError = null | null | ReferralControllerClaimUsdtBonuses429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>, TError,void, TContext> => {

const mutationKey = ['referralControllerClaimUsdtBonuses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>, void> = () => {
          

          return  referralControllerClaimUsdtBonuses(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralControllerClaimUsdtBonusesMutationResult = NonNullable<Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>>
    
    export type ReferralControllerClaimUsdtBonusesMutationError = null | null | ReferralControllerClaimUsdtBonuses429

    /**
 * @summary Claim all pending USDT referral bonuses
 */
export const useReferralControllerClaimUsdtBonuses = <TError = null | null | ReferralControllerClaimUsdtBonuses429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referralControllerClaimUsdtBonuses>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getReferralControllerClaimUsdtBonusesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Admin-only: Sets custom referral bonus configuration for a specific user and level. This overrides global configuration.
 * @summary [ADMIN] Set user-specific referral bonus configuration
 */
export const referralControllerSetUserBonusConfig = (
    setUserBonusConfigDto: SetUserBonusConfigDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerSetUserBonusConfig200 | null>(
      {url: `/referrals/admin/user-bonus-config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setUserBonusConfigDto, signal
    },
      options);
    }
  


export const getReferralControllerSetUserBonusConfigMutationOptions = <TError = null | null | ReferralControllerSetUserBonusConfig429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>, TError,{data: SetUserBonusConfigDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>, TError,{data: SetUserBonusConfigDto}, TContext> => {

const mutationKey = ['referralControllerSetUserBonusConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>, {data: SetUserBonusConfigDto}> = (props) => {
          const {data} = props ?? {};

          return  referralControllerSetUserBonusConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralControllerSetUserBonusConfigMutationResult = NonNullable<Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>>
    export type ReferralControllerSetUserBonusConfigMutationBody = SetUserBonusConfigDto
    export type ReferralControllerSetUserBonusConfigMutationError = null | null | ReferralControllerSetUserBonusConfig429

    /**
 * @summary [ADMIN] Set user-specific referral bonus configuration
 */
export const useReferralControllerSetUserBonusConfig = <TError = null | null | ReferralControllerSetUserBonusConfig429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>, TError,{data: SetUserBonusConfigDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referralControllerSetUserBonusConfig>>,
        TError,
        {data: SetUserBonusConfigDto},
        TContext
      > => {

      const mutationOptions = getReferralControllerSetUserBonusConfigMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Dev-only: clears referral relationships for the given user. Scope can be inviter, invitee, or all.
 * @summary [DEV] Clear referral links for user
 */
export const referralControllerClearForUser = (
    userId: string,
    params?: ReferralControllerClearForUserParams,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ReferralControllerClearForUser200>(
      {url: `/referrals/admin/clear/${userId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getReferralControllerClearForUserMutationOptions = <TError = ReferralControllerClearForUser401 | null | ReferralControllerClearForUser429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClearForUser>>, TError,{userId: string;params?: ReferralControllerClearForUserParams}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof referralControllerClearForUser>>, TError,{userId: string;params?: ReferralControllerClearForUserParams}, TContext> => {

const mutationKey = ['referralControllerClearForUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralControllerClearForUser>>, {userId: string;params?: ReferralControllerClearForUserParams}> = (props) => {
          const {userId,params} = props ?? {};

          return  referralControllerClearForUser(userId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralControllerClearForUserMutationResult = NonNullable<Awaited<ReturnType<typeof referralControllerClearForUser>>>
    
    export type ReferralControllerClearForUserMutationError = ReferralControllerClearForUser401 | null | ReferralControllerClearForUser429

    /**
 * @summary [DEV] Clear referral links for user
 */
export const useReferralControllerClearForUser = <TError = ReferralControllerClearForUser401 | null | ReferralControllerClearForUser429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerClearForUser>>, TError,{userId: string;params?: ReferralControllerClearForUserParams}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referralControllerClearForUser>>,
        TError,
        {userId: string;params?: ReferralControllerClearForUserParams},
        TContext
      > => {

      const mutationOptions = getReferralControllerClearForUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Dev-only: creates a referral relationship by inviterId → inviteeId using ProcessReferralRegistrationCommand.
 * @summary [DEV] Bind invitee to inviter
 */
export const referralControllerBind = (
    referralControllerBindBody: ReferralControllerBindBody,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ReferralControllerBind200 | null>(
      {url: `/referrals/admin/bind`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: referralControllerBindBody, signal
    },
      options);
    }
  


export const getReferralControllerBindMutationOptions = <TError = null | ReferralControllerBind401 | null | ReferralControllerBind429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerBind>>, TError,{data: ReferralControllerBindBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof referralControllerBind>>, TError,{data: ReferralControllerBindBody}, TContext> => {

const mutationKey = ['referralControllerBind'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referralControllerBind>>, {data: ReferralControllerBindBody}> = (props) => {
          const {data} = props ?? {};

          return  referralControllerBind(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferralControllerBindMutationResult = NonNullable<Awaited<ReturnType<typeof referralControllerBind>>>
    export type ReferralControllerBindMutationBody = ReferralControllerBindBody
    export type ReferralControllerBindMutationError = null | ReferralControllerBind401 | null | ReferralControllerBind429

    /**
 * @summary [DEV] Bind invitee to inviter
 */
export const useReferralControllerBind = <TError = null | ReferralControllerBind401 | null | ReferralControllerBind429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referralControllerBind>>, TError,{data: ReferralControllerBindBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referralControllerBind>>,
        TError,
        {data: ReferralControllerBindBody},
        TContext
      > => {

      const mutationOptions = getReferralControllerBindMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    